import {
  IPagination,
  IPagingResponse,
  IResponse,
} from 'interface/base.interface';
import axiosClient from './axiosClient';
import {
  IApproveOrderResponse,
  ICreateApprove,
} from 'interface/approve.interface';

const ApprovalApi = {
  getApproval: (params?: IPagination): Promise<IPagingResponse<any>> => {
    return axiosClient.get('abe/pof-setting-approve/get-many', { params });
  },
  getAllDivision: (): Promise<any> => {
    return axiosClient.get('abe/plant/get-all-division');
  },
  postApproval: (data?: ICreateApprove): Promise<IResponse> => {
    return axiosClient.post('abe/pof-setting-approve', data);
  },
  putApproval: (data?: ICreateApprove): Promise<IResponse> => {
    return axiosClient.put('abe/pof-setting-approve', data);
  },
  getAllCategory: (): Promise<any> => {
    return axiosClient.get('abe/pof-type');
  },
  searchApproval: (values?: Array<any>, params?: IPagination): Promise<any> => {
    let apiString = 'abe/pof-setting-approve/get-many?';
    apiString =
      (values || [])[0] == 0
        ? apiString
        : apiString.concat(`&division_id=${(values || [])[0]}`);
    apiString =
      (values || [])[1] == 0
        ? apiString
        : apiString.concat(`&created_by=${(values || [])[1]}`);
    apiString =
      (values || [])[2] == 0
        ? apiString
        : apiString.concat(`&from_date=${(values || [])[2]}`);
    apiString =
      (values || [])[3] == 0
        ? apiString
        : apiString.concat(`&to_date=${(values || [])[3]}`);
    return axiosClient.get(apiString, { params });
  },

  getListCartApproved: (params: any): Promise<IPagingResponse<any>> => {
    return axiosClient.get(`abe/cart/list-cart-approved`, { params });
  },
  getApproveOrderCHT: (
    params?: any,
    plant_id?: number
  ): Promise<IApproveOrderResponse> => {
    return axiosClient.get(
      `abe/cart-order/cht/get-approving-order/${plant_id}`,
      { params }
    );
  },

  getCartOrderBranch: (params?: any): Promise<IApproveOrderResponse> => {
    return axiosClient.get(`abe/cart-order-branch`, { params });
  },

  getCategoryApprovalList: (
    page: number,
    pageSize: number,
    searchParam: any
  ): Promise<IApproveOrderResponse> => {
    return axiosClient.get('abe/portfolio/pof-approve-list', {
      params: searchParam,
    });
  },

  approveOrDeny: (
    param: { status: string; description: string },
    POFcode: string
  ) => {
    return axiosClient.patch(`abe/portfolio/approve-pof/${POFcode}`, param);
  },
};
export default ApprovalApi;
